import { api } from "@/shared/api";

import { dominantColor } from "../../../model/hostExtras";

/** 取色前把 logo 缩到这个边长以内(取色只要分布,不要细节)。 */
const SAMPLE_SIDE = 96;

/**
 * 从 logo 取主色(1009 品牌配色「从 logo 取色」)。**放前端做**:
 *  - logo 已经在宿主上(或外链),api 那边没有它的字节;后端取色要再从宿主拉一遍图,ImageIO 还认不了 webp;
 *  - 浏览器能解所有它能显示的格式;图走 api 图片代理(同源 blob),canvas 不会被跨域污染。
 * 算法在 `model/hostExtras.dominantColor`(纯函数,有单测);取不出彩色(黑白 logo)回 null。
 */
export async function logoColor(url: string): Promise<string | null> {
  const res = await api.getBlob(`/website/image-proxy?url=${encodeURIComponent(url)}`);
  if (!res.ok) throw new Error(`取 logo 失败(${res.status})`);
  const bitmap = await createImageBitmap(await res.blob());
  const scale = Math.min(1, SAMPLE_SIDE / Math.max(bitmap.width, bitmap.height));
  const w = Math.max(1, Math.round(bitmap.width * scale));
  const h = Math.max(1, Math.round(bitmap.height * scale));
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("浏览器不支持取色");
  ctx.drawImage(bitmap, 0, 0, w, h);
  return dominantColor(ctx.getImageData(0, 0, w, h).data);
}
